export default function Hero() {
  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden pt-16 md:pt-0">
      {/* Background Image - Used Cars Dealership */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/3c2ef706b5e9d6c042e0f496d37b345f.jpg"
          alt="Used Cars Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content - Centered */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 xl:px-24 max-w-7xl mx-auto text-center">
        <div className="max-w-4xl mx-auto">
          {/* Text Block with Dark Overlay Background */}
          <div className="bg-black/40 backdrop-blur-sm px-4 md:px-8 py-6 md:py-10 rounded-2xl">
            {/* Main Copy - Improved line height and reduced font size */}
            <h1 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-black text-white leading-relaxed mb-6 md:mb-10 font-serif">
              なぜ、この「中古車ビジネス」は<br />
              ほぼ独占状態で利益を生み続けているのか。
            </h1>

            {/* Sub Copy - Enhanced */}
            <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed mb-8 md:mb-12 font-serif font-bold">
              <span className="text-[#D4AF37]">低与信者1,000万人市場</span> × <span className="text-[#D4AF37]">回収率0.5%</span><br />
              他社が真似できない「特殊な構造」の全貌を、<br />
              WEBセミナーですべて公開します。
            </p>

            {/* CTA Button */}
            <div className="flex justify-center px-4">
              <a 
                href="https://forms.gle/vdJZoFV3tEuxApQD7"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative bg-gradient-to-r from-[#D4AF37] to-[#F4C542] text-[#0A1628] font-bold text-xs md:text-lg px-4 md:px-12 py-3 md:py-6 rounded-full flex items-center gap-2 md:gap-4 hover:shadow-2xl hover:shadow-[#D4AF37]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-serif w-full md:w-auto max-w-[85%] md:max-w-none justify-center"
              >
                【無料】WEBセミナーに申し込む
                <div className="w-7 h-7 md:w-10 md:h-10 flex items-center justify-center bg-white rounded-full group-hover:translate-x-1 transition-transform duration-300 flex-shrink-0">
                  <i className="ri-arrow-right-line text-[#0A1628] text-base md:text-xl"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-[#D4AF37] text-3xl"></i>
      </div>
    </section>
  );
}
